module.exports = __webpack_public_path__ + "img/white.2d70227e.jpg";